/**
 * Utility functions for image URL construction
 */

export const getImageUrl = (imagePath) => {
  const blogImagePath = process.env.REACT_PATH_FOR__BLOG_IMAGE;

  const BACKEND_URL = process.env.REACT_APP_API_BASE_URL || '';
  if (!blogImagePath) {
    console.error('REACT_PATH_FOR__BLOG_IMAGE environment variable is not set!');
    console.error('Using fallback URL for development...');
    // Fallback for development
    return imagePath ? `${BACKEND_URL}/${imagePath}` : '';
  }
  
  // If imagePath already has http/https, return as is
  if (imagePath && (imagePath.startsWith('http://') || imagePath.startsWith('https://'))) {
    return imagePath;
  }
  
  // If imagePath starts with /, remove it to avoid double slashes
  const cleanPath = imagePath && imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
  
  return cleanPath ? `${blogImagePath}/${cleanPath}` : '';
};

export const getBlogImageUrl = (imageFilename) => {
  return getImageUrl(`uploads/blogs/${imageFilename}`);
};
